/**
 * Header Slider Navigation Custom Element
 * Connects header navigation buttons to hidden slider buttons
 * Usage: <header-slider-navigation data-slider-id="Slider-123">
 */

if (!customElements.get('header-slider-navigation')) {
  customElements.define(
    'header-slider-navigation',
    class HeaderSliderNavigation extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      /**
       * Initialize the header navigation component
       */
      init() {
        const sliderId = this.dataset.sliderId;
        if (!sliderId) return;

        const section = this.closest('[id^="shopify-section-"]');
        if (!section) return;

        this.bindNavigationButtons(section);
      }

      /**
       * Bind header navigation buttons to hidden slider buttons
       * @param {HTMLElement} section - The section container
       */
      bindNavigationButtons(section) {
        const headerPrevButton = this.querySelector('.slider-button--prev');
        const headerNextButton = this.querySelector('.slider-button--next');
        const hiddenPrevButton = section.querySelector('.slider-buttons .slider-button--prev');
        const hiddenNextButton = section.querySelector('.slider-buttons .slider-button--next');

        if (headerPrevButton && hiddenPrevButton) {
          headerPrevButton.addEventListener('click', (event) => {
            event.preventDefault();
            hiddenPrevButton.click();
          });
        }

        if (headerNextButton && hiddenNextButton) {
          headerNextButton.addEventListener('click', (event) => {
            event.preventDefault();
            hiddenNextButton.click();
          });
        }
      }
    }
  );
}